import { cloneDeep } from 'lodash-es';
import {
  fullNameNoSuffixSchema,
  fullNameNoSuffixUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  claimantFields,
  claimantInformationText,
} from '../definitions/constants';

const DESCRIPTION_FIELD = 'view:claimantInformationDescription';

const descriptionUI = description => ({
  [DESCRIPTION_FIELD]: {
    'ui:field': 'ViewField',
    'ui:description': description,
  },
});

const descriptionSchema = {
  [DESCRIPTION_FIELD]: {
    type: 'object',
    properties: {},
  },
};

const claimantFullNameUI = cloneDeep(fullNameNoSuffixUI());
claimantFullNameUI.first['ui:title'] = claimantInformationText.firstNameTitle;
claimantFullNameUI.first['ui:errorMessages'] = {
  required: claimantInformationText.firstNameError,
};
claimantFullNameUI.middle['ui:title'] =
  claimantInformationText.middleInitialTitle;
claimantFullNameUI.last['ui:title'] = claimantInformationText.lastNameTitle;
claimantFullNameUI.last['ui:errorMessages'] = {
  required: claimantInformationText.lastNameError,
};

const claimantFullNameSchema = cloneDeep(fullNameNoSuffixSchema);
if (claimantFullNameSchema?.properties?.middle) {
  claimantFullNameSchema.properties.middle.maxLength = 1;
}

export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true, forceDivWrapper: true },
    ...titleUI(claimantInformationText.pageTitle),
    ...descriptionUI(claimantInformationText.pageDescription),
    [claimantFields.parentObject]: {
      [claimantFields.fullName]: claimantFullNameUI,
    },
  },
  schema: {
    type: 'object',
    properties: {
      ...descriptionSchema,
      [claimantFields.parentObject]: {
        type: 'object',
        properties: {
          [claimantFields.fullName]: claimantFullNameSchema,
        },
        required: [claimantFields.fullName],
      },
    },
  },
};
